export default "images/导航 (3).png";